import CountryPageRenderer from '../components/CountryPageRenderer';
import argentinaData from '../data/country-pages/argentina';

export default function ArgentinaCountryPage() {
  return <CountryPageRenderer data={argentinaData} />;
}
